export default __webpack_public_path__ + "locales/cs/DeleteDialog.json?hash=39b6827fc28d3d9713c8f3bf4c13ac6e";